import 'whatwg-fetch';
const apiUrl = require('./apiUrl');
const fetch = require('node-fetch');

import axios from 'axios';

var fetchData = {
  isDebug: function() {
    return window.location.href.indexOf('51ping') > -1 || window.location.href.indexOf('fe.dev.sankuai.com') > -1 ? true : false
  },
  get(obj){
    let url = 'https:' + this.generateUrl(obj)
    return axios.get(url,{
      withCredentials: true
    })
  },
  getdata: function(obj){
    let url = 'https:' + this.generateUrl(obj)

    // 本地调试
    // if (this.generateUrl(obj).indexOf(':8080') != -1) {
    //   url = 'http:' + this.generateUrl(obj)
    // }

    let requestObj = this.createRequest(obj)
    console.log(requestObj)
    return fetch(url, requestObj)
            .then(
              (resp)=>resp.json()
            )
  },
  createRequest: function (obj){
    let headers = new Headers()
    if (obj.method == 'post'){
      headers = {
          "Content-Type": "application/json"
      }
      return {
        method: 'POST',
        body: JSON.stringify(obj.data),
        headers: headers,
        credentials: 'include',   //允许发送all sites的cookies
        mode: 'cors'    //support cross origin
      };
    }
    return  {
      method: obj.method,
      body: obj.data,
      headers: headers    
    };
    //
    // let headers = new Headers({
    //       "Content-Type": "application/x-www-form-urlencoded"
    //   })
    //   // return {
    //   //   method: 'POST',
    //   //   body: JSON.stringify(obj.data),
    //   //   headers: headers,
    //   //   credentials: 'include',   //允许发送all sites的cookies
    //   //   mode: 'cors'    //support cross origin
    //   // };
    
    //   if (obj.method == 'post'){
    //     headers = {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/x-www-form-urlencoded'
    //     }
    //     let formdata = ''
    //     for(let key in obj.data){
    //       formdata  += key +'='+obj.data[key] + '&'
    //     }
    //     formdata = formdata.slice(0, formdata.length-1)
    //     debugger;
    //     return {
    //       method: 'POST',
    //       body: formdata,
    //       credentials: 'include',
    //       headers,
    //       mode: 'cors',
    //     };
    // }
    // return  {
    //   method: obj.method,
    //   body: obj.data,
    //   headers: headers
    // };

  },
  generateUrl: function (obj){
    let URLtype = 'ApiUrl'
    if(this.isDebug()){
      URLtype = 'DebuggerUrl'
    }
    if(!obj.method || obj.method == 'GET'){
      obj.method = 'GET'
      let localUrl = apiUrl.default[URLtype][obj.urlname] + '?'
      for(let key in obj.data){
        localUrl += key + '=' + obj.data[key] + '&'
      }
      return localUrl
    }else{
      return apiUrl.default[URLtype][obj.urlname].toString()
    }
  },
  getHref(type,id){
    let commonId = id || ''
    return apiUrl.default["forwardUrl"][type] + commonId.toString()
  },
  fetchApiForFloor2 (url, option) {
    return new Promise ((resolve,reject) => {
      fetch(url, option)
      .then(response => {
          return response.json();
      })
      .then(res => {
          if(res && (res.code === 200||res.success)){
              resolve(res);
          } else {
              resolve(res);
          }
      })
      .catch(e => {
          reject('request fail:'+e.stack);
      });
    });
  }
}
export default fetchData



// WEBPACK FOOTER //
// ./src/libs/fetchData.js